import React from 'react';
import S from './FooterCopyright.styles';
const FooterCopyright = ({ copyright }) => {
    return React.createElement(S.Container, null, copyright);
};
export default FooterCopyright;
